<template>
<div id='trafico'>
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>

                <v-stepper v-model="e1" >
                    <v-card class="primary white--text titulocatalogo" >
                        <v-icon small class="white--text" >library_books</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Administrar Tráfico</strong>
                        </span>
                    </v-card>

                    <v-stepper-header style='margin-top: 50px'>
                        <v-stepper-step :complete="e1 > 1" step="1" @click="e1 = 1" >Datos Generales</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step v-if="saveDatosGenerales" :complete="e1 > 2" step="2" @click="e1 = 2" >Detalle Carga</v-stepper-step>

                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1" >
                            <div id='datos_generales'>
                                <v-datos-generales-component :saveDatosGenerales="saveDatosGenerales" @updateSave="updateSave" />
                            </div>

                            <v-btn color="primary" @click="e1 = 2" v-if="saveDatosGenerales" >
                                Sigueinte
                            </v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="2" >
                            <div id='detalle_carga'>
                                <v-detalle-carga-component :referencia="referencia" />
                            </div>

                            <v-btn color="primary" @click="e1 = 3" >
                                Sigueinte
                            </v-btn>

                            <v-btn text @click="e1 = 1" >Cancel</v-btn>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>

            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import datosGenerales from "@/components/trafico/DatosGenerales.vue";
import detalleCarga from "@/components/trafico/DetalleCarga.vue";

export default {
    components: {
        "v-datos-generales-component": datosGenerales,
        "v-detalle-carga-component": detalleCarga
    },
    created() {

    },
    methods: {
        updateSave(value) {
            this.saveDatosGenerales = value;
        },
    },

    data: () => ({
        fab: false,
        e1: 0,
        saveDatosGenerales: false,
        referencia: '12121-21212',

        url_actions: "trafico/",
        url_list: "trafico/list/",
        tabla: 1,
        title: "TRÁFICO",
        columns: ["clave", "descripcion", "actions"],
        options: {
            filterable: ["clave", "descripcion"],
            sortable: ["clave", "descripcion"],

            headings: {
                clave: "Clave",
                descripcion: "Descripción",
                actions: "Operaciones"
            }
        },
        camposexcel: {
            "Clave": "clave",
            Descripción: "descripcion"
        },
        encabezadoLayout: {
            "clave": "clave",
            "descripcion": "descripcion"
        },
        camposLayout: [{
            "clave": "",
            "descripcion": ""
        }],
        model: {
            id: 0,
            clave: "",
            descripcion: "",
        },
        form: {
            clave: {
                requiered: true,
                label: "Clave",
                value: "",
                maxlen: 10
            },
            descripcion: {
                requiered: true,
                label: "Descripción",
                value: "",
                maxlen: 200
            },
        },
        breadcrumbs: [
                {
                    text: "Tráficos",
                    disabled: false,
                    to: "/trafico_index"
                },
            {
                text: "Tráfico",
                disabled: true,
                to: ""
            },

        ],

    }),

};
</script>
